import { Injectable, signal, computed } from '@angular/core';
import { CustomerDto } from 'src/publicproxy/src/proxy/dto-common-website/customers';

@Injectable({ providedIn: 'root' })
export class UserStore {

    private _userConnected = signal<any | null>(null);
    private _userCard = signal<any | null>(null);
    private _customer = signal<CustomerDto | null>(null);

    readonly userConnected = computed(() => this._userConnected());
    readonly userCard = computed(() => this._userCard());
    /** Client connecté sur le site customer, affiché dans le header. */
    readonly customer = computed(() => this._customer());

    setUserConnected(user: any) {
        this._userConnected.set(user);
    }

    setUserCard(user: any) {
        this._userCard.set(user);
    }

    clearUserConnected() {
        this._userConnected.set(null);
    }

    clearUserCard() {
        this._userCard.set(null);
    }

    setCustomer(customer: CustomerDto) {
        this._customer.set(customer);
    }

    /** Reporte une modification enregistrée sur le client déjà chargé ; sans effet s'il ne l'est pas. */
    patchCustomer(changes: Partial<CustomerDto>) {
        this._customer.update(customer => customer && { ...customer, ...changes });
    }

    clearCustomer() {
        this._customer.set(null);
    }

    isLoggedIn = computed(() => !!this._userConnected());
}
